/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "9871150a0c48610fa553aa9de4d127e857d6be26";
